var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartIconFilled = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.402 4.62A5.376 5.376 0 0 0 16.542 3c-1.391 0-2.792.54-3.862 1.62l-.68.69-.68-.69A5.432 5.432 0 0 0 7.449 3c-1.4 0-2.79.54-3.851 1.62-2.13 2.18-2.13 5.68 0 7.84L12.01 21l7.712-7.84.68-.69c2.13-2.17 2.13-5.67 0-7.85"
  })));
};
export default SvgHeartIconFilled;